// extracted by mini-css-extract-plugin
export default {"container":"Toast_container__XSuf-","toast-slide-down-fade":"Toast_toast-slide-down-fade__FECf4","title":"Toast_title__vjRj+","body":"Toast_body__PoUF1"};